import VueI18n from 'vue-i18n'
import Vue from 'vue'
// import store from '@/store/index'
import englishKeys from './keys/en'
import spanishKeys from './keys/es'
import portugueseKeys from './keys/pt'

import { languageList, isValidLocale } from './_constants/lang'

// TODO: Change locale to user config locale when implemented

const locale = navigator.language.substring(0, 2) === 'es' ? 'es' : 'en'
const messages = {
  en: englishKeys,
  es: spanishKeys,
  pt: portugueseKeys
}
const dateTimeFormats = {
  'es': {

    month_day: {
      day: 'numeric',
      month: 'long'
    },
    day: {
      weekday: 'long'
    },
    month: {
        month: 'long', year: 'numeric'
    },
    month_only: {
      month: 'long'
    },
    long: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    short: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }

  },
  'en': {
    day: {

      weekday: 'long'
    },
    month: {
      month: 'long', year: 'numeric'
    },
    month_day: {
      day: 'numeric',
      month: 'long'
    },
    month_only: {
      month: 'long'
    },
    short: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    },
    long: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }

  },
  'pt': {

    month_day: {
      day: 'numeric',
      month: 'long'
    },
    day: {
      weekday: 'long'
    },
    month: {
        month: 'long', year: 'numeric'
    },
    month_only: {
      month: 'long'
    },
    long: {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    },
    short: {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric'
    }

  }

}

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale,
  dateTimeFormats,
  fallbackLocale: 'es',
  messages
})

const loadedLanguages = ['es', 'en', 'pt']

function setI18nLanguage (lang) {
  i18n.locale = lang
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}
export function loadLanguageAsync (lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  // return import(/* webpackChunkName: "lang-[request]" */ `@/locales/keys/${lang}.js`).then(

  // const importRoute =
  return import(/* webpackChunkName: "lang-[request]" */ `@/locales/keys/${lang}.js`).then(
    texts => {
      i18n.setLocaleMessage(lang, texts.default)
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    }
  )
}

export function setLanguage (lang) {
  let language = ''
  if (!lang || !isValidLocale(lang)) {
    // Default language spanish
    language = languageList.find(el => el.default)
  } else {
    language = languageList.find(el => el.locale === lang)
  }
  localStorage.setItem('lang', language.locale)
  loadLanguageAsync(language.locale)
}

// export function initializeLanguage (langQuery) {
//   // if (store.getters['UsersStore/User']) {
//   //   setLanguage(store.getters['UsersStore/User'].locale)
//   //   return
//   // }
//   if (langQuery) {
//     setLanguage(langQuery)
//     return
//   }
//   if ('lang' in localStorage) {
//     const locale = localStorage.getItem('lang')
//     loadLanguageAsync(locale)
//   } else {
//     setLanguage()
//   }
// }
export default i18n
